var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{class:{
    'router-link-exact-active': _vm.isCurrentLocationCategory(_vm.$route.query.locationCategory),
  }},[_c('Flex',{class:{ 'cursor-pointer': true }},[_c('router-link',{staticClass:"location-link",attrs:{"to":_vm.getRoute(_vm.locationCategory)}},[_vm._v(" "+_vm._s(_vm.locationCategory.name)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }